export const myBeeHomePage = 'MyBEE123Homepage/';
export const getBEEUserScorecards = myBeeHomePage + 'GetBEEUserScorecards';
export const getEEUserScorecards = myBeeHomePage + 'GetEEUserScorecards';
export const getAllUserScorecards = myBeeHomePage + 'GetUserScorecards';